import { Injectable } from "@angular/core";
import { Capacitor } from "@capacitor/core";
import { Network } from "@capacitor/network";
import { BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class NetworkService {
  private isConnected = new BehaviorSubject<boolean>(false); // Observable to hold the network status

  constructor() {
    this.initializeNetworkEvents();
  }

  updateNetworkStatus = () => {
    this.isConnected.next(navigator.onLine);
  };
  // Initialize network status check and event listener
  private async initializeNetworkEvents() {
    // Check if we are running on a native platform
    if (Capacitor.isNativePlatform()) {
      const status = await Network.getStatus();
      this.isConnected.next(status.connected);
      Network.addListener("networkStatusChange", (status) => {
        this.isConnected.next(status.connected);
      });
    } else {
      this.updateNetworkStatus();

      window.addEventListener("online", () => this.isConnected.next(true));
      window.addEventListener("offline",() => this.isConnected.next(false));
    }
  }

  // Get the current network status as an Observable
  public getNetworkStatus() {
    return this.isConnected.asObservable();
  }
}
